export default __webpack_public_path__ + "static/media/list-textLW.681defe9.svg";